import React from 'react'
import { TextField } from 'material-ui'
import Edit from '../crud/edit'
import MultiInput from '../multi-input'

const fields = [
  {
    name: 'Affirmations',
    prop: 'value',
    type: 'component',
    component: MultiInput,
    componentProps: {
      component: TextField,
      componentProps: {
        required: true
      }
    }
  }
]

const Affirmations = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Affirmations'
      fields={fields}
      apiPath='admin/settings/affirmations'
      successRedirectPath='/settings'
      disableDelete
    />
  )
}

export default Affirmations
